/* Afridi Imports — info pages behaviour (chip nav, FAQ search, accordion tools, sticky bar). */
(function () {
  'use strict';
  var root = document.querySelector('.aip');
  if (!root) return;

  /* ---- Offset for the theme's sticky header ---- */
  var headerH = function () {
    var h = document.querySelector('#shopify-section-header-inline, .t4s-section-header, header.shopify-section');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') { var inner = h.querySelector('[class*="sticky"], .t4s-header__wrapper'); if (inner && getComputedStyle(inner).position === 'fixed') h = inner; else return 0; }
    var r = h.getBoundingClientRect();
    return r.top <= 1 ? Math.round(r.height) : 0;
  };
  var setTop = function () { document.documentElement.style.setProperty('--aip-top', headerH() + 'px'); };
  setTop(); window.addEventListener('resize', setTop); window.addEventListener('scroll', setTop, { passive: true });

  /* ---- Chip nav: active state + smooth scroll ---- */
  var nav = root.querySelector('.aip-nav');
  if (nav) {
    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var setActive = function (id) {
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', on);
        if (on && nav.scrollWidth > nav.clientWidth) {
          var r = a.getBoundingClientRect(), c = nav.getBoundingClientRect();
          if (r.left < c.left || r.right > c.right) a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
    };
    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        var t = targets[i]; if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.pageYOffset - (headerH() + nav.offsetHeight + 12);
        window.scrollTo({ top: y, behavior: 'smooth' });
        setActive(t.id);
        if (t.tagName === 'DETAILS') t.open = true;
        history.replaceState(null, '', '#' + t.id);
      });
    });
    if ('IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting; });
        var first = targets.filter(function (t) { return t && seen[t.id]; })[0];
        if (first) setActive(first.id);
      }, { rootMargin: '-' + (headerH() + nav.offsetHeight + 20) + 'px 0px -60% 0px', threshold: 0 });
      targets.forEach(function (t) { if (t) io.observe(t); });
    }
  }

  /* ---- Open the accordion item from the URL hash ---- */
  var openHash = function () {
    var id = location.hash.slice(1); if (!id) return;
    var el = document.getElementById(id); if (!el) return;
    if (el.tagName === 'DETAILS') el.open = true;
    var d = el.closest && el.closest('details'); if (d) d.open = true;
  };
  openHash(); window.addEventListener('hashchange', openHash);

  /* ---- Expand / collapse all ---- */
  root.querySelectorAll('[data-acc-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('data-acc-toggle') === 'open';
      root.querySelectorAll('.aip-acc details').forEach(function (d) { d.open = open; });
    });
  });

  /* ---- FAQ search ---- */
  var search = root.querySelector('.aip-search input');
  if (search) {
    var wrap = search.closest('.aip-search');
    var clear = wrap.querySelector('.aip-search-clear');
    var empty = root.querySelector('.aip-empty');
    var items = [].slice.call(root.querySelectorAll('.aip-acc details'));
    items.forEach(function (d) { d.__txt = (d.textContent + ' ' + (d.getAttribute('data-tags') || '')).toLowerCase(); });
    var sections = [].slice.call(root.querySelectorAll('.aip-section'));
    var run = function () {
      var q = search.value.trim().toLowerCase();
      wrap.classList.toggle('has-q', !!q);
      root.classList.toggle('is-filtering', !!q);
      if (!q) { items.forEach(function (d) { d.classList.remove('is-hide'); }); sections.forEach(function (s) { s.classList.remove('is-hide'); }); if (empty) empty.classList.remove('is-on'); return; }
      var words = q.split(/\s+/), shown = 0;
      items.forEach(function (d) {
        var hit = words.every(function (w) { return d.__txt.indexOf(w) > -1; });
        d.classList.toggle('is-hide', !hit);
        if (hit) { shown++; d.open = true; }
      });
      sections.forEach(function (s) {
        var any = s.querySelector('.aip-acc details:not(.is-hide)');
        s.classList.toggle('is-hide', !any);
      });
      if (empty) empty.classList.toggle('is-on', shown === 0);
    };
    var t; search.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 120); });
    if (clear) clear.addEventListener('click', function () { search.value = ''; run(); search.focus(); });
  }

  /* ---- Sticky bottom bar: hide when footer is in view ---- */
  var bar = root.querySelector('.aip-bar');
  if (bar) {
    var foot = document.querySelector('.afx, footer');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-hidden', en[0].isIntersecting); }, { threshold: 0 }).observe(foot);
    }
  }

  /* ---- Return form: light client validation + phone normalisation ---- */
  var form = root.querySelector('form.aip-claim');
  if (form) {
    form.addEventListener('submit', function (e) {
      var phone = form.querySelector('[name=phone]');
      if (phone) {
        var v = phone.value.replace(/[^\d+]/g, '');
        if (v.replace(/\D/g, '').length < 10) { e.preventDefault(); phone.focus(); phone.setCustomValidity('Please enter a valid mobile number, e.g. 03XX XXXXXXX'); phone.reportValidity(); return; }
        phone.setCustomValidity('');
      }
      var btn = form.querySelector('button[type=submit]');
      if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }
    });
    form.querySelectorAll('input,select,textarea').forEach(function (f) { f.addEventListener('input', function () { f.setCustomValidity(''); }); });
  }
})();
